<template>
  <div id="app">
    <loadingcomp
        v-bind:mesaj="loadingmesaj"
        v-model="loadingvmodel"
      ></loadingcomp>
      <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <v-app id="inspire" light>
      <v-dialog persistent max-width="400px">
                <v-card color="grey lighten-5">
                    <v-flex xs12 sm12>
                        <v-toolbar size="120px" dark color="info">
                            <v-toolbar-title>{{$t('Accounting-Code-Transfer')}}</v-toolbar-title>

                        </v-toolbar>
                    </v-flex>
                    <v-card-text>
                        <v-layout row="" wrap>
                            <div class="flex md12">

                                <v-form ref="formaktarim" id="formaktarim" method="post" enctype="multipart/form-data" v-model="valid" lazy-validation>
                                    <input hidden type="file" id="file" ref="file" v-on:change="handleFileUpload()" />
                                </v-form>

                                <v-layout>
                                    <v-text-field disabled="" :label="$t('XSLT-File-Name-E-Invoice')" :placeholder="dosya1mesaj" v-model="dosyayolu1">
                                    </v-text-field>
                                    <v-btn color="info" @click="addFiles()">
                                        <v-icon>attach_file</v-icon> {{ $t('Select-File') }}
                                    </v-btn>
                                    <v-tooltip bottom="" :activator="el" v-model="tooltip">
                                        <span> {{ $t('Select-File') }}</span>
                                    </v-tooltip>
                                </v-layout>

                                <v-layout>

                                </v-layout>

                            </div>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="vazgec()">{{$t('Cancel')}}</v-btn>

                        <v-tooltip bottom>
                            <v-btn slot="activator" :disabled="file.length==0" id="bkaydet" color="blue darken-1" flat @click="DosyalariYukle()"> {{ $t('Upload-Files') }}
                            </v-btn>

                            <span> {{ $t('Upload-Files') }} </span>
                        </v-tooltip>

                    </v-card-actions>
                </v-card>
            </v-dialog>
      <v-dialog scrollable="" persistent v-model="accountingCodedialog" max-width="450px">
                <v-card flat color="grey lighten-5">
                    <v-toolbar size="120px" color="info">
                        <v-toolbar-title class="white--text">Eski Muhasebe'den Kapanış Fişi Aktar</v-toolbar-title>
                        <v-spacer></v-spacer>

                    </v-toolbar>
                    <v-card-text>
                      <v-layout row wrap>
                <v-flex xs12 sm6 md12>
                                                <v-checkbox v-model="ficheReverse" label="Ters Çevir" v-bind:false-value="0"
                        v-bind:true-value="1"  hide-details>
                                                
                                                </v-checkbox>
                                            </v-flex>
               
              </v-layout>
                        <v-flex pb-2 xs12 sm12 md12>
                            <v-card flat class="white--text">
                                <v-card color="white" flat="">
                                    <v-card-actions>

                                        <v-layout row="" wrap="">
                                            <v-flex v-if="file.length==0" xs12 sm12 md12>
                                                <v-alert type="error" value="true">
                                                    <span v-if="file.length==0">{{$t('Please-select-file')}}</span>
                                                </v-alert>
                                            </v-flex>
                                            <v-form ref="formek" v-model="valid" lazy-validation>

                                                <v-flex xs12 sm12 md12>
                                                    <v-layout row wrap>

                                                        <v-flex xs12 sm12 md12>

                                                            <v-form ref="formaktarim" id="formaktarim" method="post" enctype="multipart/form-data" v-model="valid" lazy-validation>
                                                                <input hidden :rules="[v => !!v || $t('Mandatory-Areas')]" type="file" id="file" ref="file" multiple v-on:change="handleFileUpload2()" />
                                                            </v-form>
                                                            <v-btn flat :loading="false" :disabled="false" color="info" @click="addFiles()">
                                                                <v-icon color="info" left>attach_file
                                                                </v-icon>{{$t('Select-File')}}
                                                            </v-btn>
                                                        </v-flex>

                                                        <v-flex pt-2 pl-2 pb-2 v-if="file.length>0" xs12 sm12 md8>
                                                            <span>{{file.length}}  {{$t('pcs-of-files-selected')}}</span>
                                                        </v-flex>

                                                        <v-flex xs12 sm12 md12>
                                                            <v-layout fill-height align-center>
                                                                <span class="grey--text title">
                                                                    {{ secilendosya}}</span>
                                                            </v-layout>
                                                        </v-flex>
                                                        <ul id="ulList">
                                                        </ul>

                                                        <v-flex xs12 pt-2 sm12 md12>
                                                            <v-layout justify-end>

                                                            </v-layout>
                                                        </v-flex>

                                                    </v-layout>
                                                </v-flex>
                                            </v-form>

                                        </v-layout>

                                    </v-card-actions>
                                </v-card>
                            </v-card>
                        </v-flex>

                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" flat @click="accountingCodedialog = false">
                            {{$t('Close')}} </v-btn>

                        <v-btn flat @click="DosyalariYukle()" color="info">{{$t('Upload-Files')}}
                        </v-btn>

                    </v-card-actions>
                </v-card>
            </v-dialog>
      <fisNumaraDegis ref="fisNumaraDegis"></fisNumaraDegis>
      <kapanistanacilis ref="kapanistanacilis"></kapanistanacilis>
      <otomatikkapanisfisi ref="otomatikkapanisfisi"></otomatikkapanisfisi>
      <referansbirlestir ref="referansbirlestir"></referansbirlestir>
      <standartbiletentg ref="standartbiletentg"></standartbiletentg>
      <kurusyuvarla ref="kurusyuvarla"></kurusyuvarla>
      <fisKopyala ref="fisKopyala"></fisKopyala>
      <fisDegistir ref="fisDegistir"></fisDegistir>
      <firmaKopyala ref="firmaKopyala"></firmaKopyala>
      <firmaSil ref="firmaSil"></firmaSil>
      <kullaniciadiguncelle ref="kullaniciadiguncelle"></kullaniciadiguncelle>
      <deftersilmeyetkisi ref="deftersilmeyetkisi"></deftersilmeyetkisi>
      <standartBilancoSablonu ref="standartBilancoSablonu"></standartBilancoSablonu>
      <standartGelirGiderSablonu ref="standartGelirGiderSablonu"></standartGelirGiderSablonu>
      <surumGuncelle ref="surumGuncelle"></surumGuncelle>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont"
                >{{ $t('Auxiliary-Processes') }}</v-toolbar-title
              >
            </v-toolbar>
          </v-flex>
          <v-container fluid>
            <v-layout row="" wrap="">
              <v-btn
                style="width: 200px"
                color="info"
                @click="fisDialogAc()"
                dark
                >Fiş No Sırala
                <v-icon right dark>receipt</v-icon>
              </v-btn>
              <v-btn
                style="width: 200px"
                color="info"
                @click="referansDialogAc()"
                dark
                >Referansları Birleştir
                <v-icon right dark>receipt</v-icon>
              </v-btn>
              <v-btn
                style="width: 400px"
                color="info"
                @click="standartbiletentgDialogAc()"
                dark
                >Standart Bilet Entegrasyon Şablonlarını Oluştur
                <v-icon right dark>receipt</v-icon>
              </v-btn>
              <v-btn
                style="width: 300px"
                color="info"
                @click="fisDegistirDialogAc()"
                dark
                >Fiş Tarih / Numara Değiştir
                <v-icon right dark>receipt</v-icon>
              </v-btn>
              <v-btn
                style="width: 200px"
                color="info"
                @click="fisKopyalaDialogAc()"
                dark
                >Fiş Kopyala
                <v-icon right dark>receipt</v-icon>
              </v-btn>
              <v-btn
                style="width: 200px"
                color="info"
                @click="firmaKopyalaDialogAc()"
                dark
                >Firma Kopyala
                <v-icon right dark>receipt</v-icon>
              </v-btn>
              <v-btn
                style="width: 200px"
                color="info"
                @click="firmaSilDialogAc()"
                dark
                >Firma Sil
                <v-icon right dark>receipt</v-icon>
              </v-btn>
              <v-btn style="width:350px" @click.native="accountingCodedialog=true" color="info" dark>Eski Muhasebe'den Kapanış Fişi Aktar
                            <v-icon right dark>attach_file</v-icon>
                        </v-btn>
                        <v-btn
                style="width: 200px"
                color="info"
                @click="yuvarlaDialogAc()"
                dark
                >Kuruş Hanelerini Yuvarla
                <v-icon right dark>receipt</v-icon>
              </v-btn>
              <v-btn
                style="width: 300px"
                color="info"
                @click="otomatikkapanisfisiDialogAc()"
                dark
                >Otomatik Kapanış Fişi Oluştur
                <v-icon right dark>receipt</v-icon>
              </v-btn>
              <v-btn
                style="width: 300px"
                color="info"
                @click="kapanistanacilisDialogAc()"
                dark
                >Kapanış Fişinden Açılış Fişi Oluştur
                <v-icon right dark>receipt</v-icon>
              </v-btn>
              <v-btn
                style="width: 250px"
                color="info"
                @click="kullaniciAdiGuncellegDialogAc()"
                dark
                >Boş Kullanıcı Adı Güncelle
                <v-icon right dark>receipt</v-icon>
              </v-btn>
              <v-btn
                style="width: 250px"
                color="info"
                @click="deftersilmeyetkisiDialogAc()"
                dark
                >Defter Silme Yetkisi Aç
                <v-icon right dark>receipt</v-icon>
              </v-btn>
              <v-btn
                style="width: 450px"
                color="info"
                @click="standartBilancoSablonu()"
                dark
                >Standart Bilanço Şablonunu Oluştur
                <v-icon right dark>receipt</v-icon>
              </v-btn>
              <v-btn
                style="width: 450px"
                color="info"
                @click="standartGelirGiderSablonu()"
                dark
                >Standart Gelir-Gider Tablo Şablonunu Oluştur
                <v-icon right dark>receipt</v-icon>
              </v-btn>
              <v-btn
                style="width: 450px"
                color="info"
                @click="surumGuncelleAc()"
                dark
                >Sürümü Güncelle
                <v-icon right dark>receipt</v-icon>
              </v-btn>
              <!-- <router-link
                :to="{ name: 'yardimci-islemler-carisizbiletlistesi' }"
              >
                <v-btn style="width: 250px" color="info" dark
                  > {{ $t('List-Tickets-Without-Current-Processes') }}
                  <v-icon right dark>airplane_ticket</v-icon>
                </v-btn>
              </router-link> -->
            </v-layout>
          </v-container>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import helpers from "@/components/app/customcomp/helpers.js";
import auth from "../../../../api/auth";
import fisNumaraDegis from "@/components/app/muhasebe/yardimcilar/comp/fisnumarasidegis";
import referansbirlestir from "@/components/app/muhasebe/yardimcilar/comp/referansbirlestir";
import standartbiletentg from "@/components/app/muhasebe/yardimcilar/comp/standartbiletentg";
import kurusyuvarla from "@/components/app/muhasebe/yardimcilar/comp/kurusyuvarla";
import fisKopyala from "@/components/app/muhasebe/yardimcilar/comp/fiskopyala";
import fisDegistir from "@/components/app/muhasebe/yardimcilar/comp/fisdegistir";
import firmaKopyala from "@/components/app/muhasebe/yardimcilar/comp/firmakopyala";
import firmaSil from "@/components/app/muhasebe/yardimcilar/comp/firmasil";
import axios from 'axios'
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import kapanistanacilis from "./comp/kapanistanacilis.vue";
import otomatikkapanisfisi from "./comp/otomatikkapanisfisi.vue";
import kullaniciadiguncelle from "./comp/kullaniciadiguncelle.vue";
import deftersilmeyetkisi from "./comp/deftersilmeyetkisi.vue";
import standartBilancoSablonu from "./comp/standartBilancoSablonu.vue"
import standartGelirGiderSablonu from "./comp/gelirGiderTabloSablon.vue"
import surumGuncelle from "./comp/surumGuncelle.vue";
export default {
  data() {
    return {
      loadingvmodel: false,
        text1: null,
        snackbar: false,
        loadingmesaj: "İşleniyor..",
      el: null,
      valid: true,
      secilendosya: null,
      file: [],
      ficheReverse:1,
      dosyayolu1: null,
      dosya1mesaj: null,
      accountingCodedialog:false,
      tooltip: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  beforeMount: beforeMount,
  filters: {},
  components: {
    fisNumaraDegis,
    referansbirlestir,
    standartbiletentg,
    fisKopyala,
    fisDegistir,
    firmaKopyala,
    firmaSil,
    loadingcomp,
    snackbarcomp,
    kurusyuvarla,
    otomatikkapanisfisi,
    kapanistanacilis,
    kullaniciadiguncelle,
    deftersilmeyetkisi,
    standartBilancoSablonu,
    standartGelirGiderSablonu,
    surumGuncelle
  },
  methods: {
    handleFileUpload2() {
            this.file = []

            if (this.$refs.file.files != [] && this.$refs.file.files != null) {
                var uploadedFiles = this.$refs.file.files;

                var fp = document.getElementById('file');

                var lg = uploadedFiles.length; // get length
                if (lg > 0) {
                    this.dosya1mesaj = lg +  " " + this.$t('pcs-of-files-selected')
                } else {
                    this.dosya1mesaj = this.$t('file-has-been-chosen')
                }
                document.getElementById('ulList').innerHTML = '';

                var items = uploadedFiles
                var fragment = "";

                if (lg > 0) {
                    for (var i = 0; i < lg; i++) {
                        var fileName = items[i].name; // get file name
                        var fileSize = items[i].size; // get file size
                        var fileType = items[i].type; // get file type

                        // append li to UL tag to display File info
                        fragment += "<li>" + fileName + " (<b>" + fileSize +
                            "</b> bytes)" // + "- Type :" + fileType + "</li>";
                    }
                    document.getElementById('ulList').innerHTML = fragment;
                    //contentWindow.document.body.innerHTML = response.body;
                    // $("#ulList").append(fragment);
                }

                if (uploadedFiles.length > 0) {

                    for (var i = 0; i < uploadedFiles.length; i++) {
                        this.file.push(uploadedFiles[i]);
                    }

                } 
            }

        },
    addFiles() {
            this.$refs.file.click();
        },
       
    DosyalariYukle() {
            var cred = JSON.parse(window.localStorage.getItem('credentials'));

            if (this.file.length > 0) {
                this.loadingvmodel = true
                let formData = new FormData();
                for (var i = 0; i < this.file.length; i++) {
                    let file = this.file[i];
                    formData.append('file[' + i + ']', file);
                    formData.append('CustomerCode', cred.AnaSirketKodu)
                    formData.append('CompanyCode', cred.SirketKodu)
                    formData.append('AccountingCompanyID', cred.MuhasebeSirketNo)
                   
                    axios.defaults.baseURL = auth.API_URL;
                    axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
                    axios.post(auth.API_URL + 'api/AccountingParameters/FileUploadAccountingStream',
                            formData, {
                                headers: {
                                    Authorization: `Bearer ${auth.getAuthHeader()}`
                                }
                            }
                        ).then((response) => {

                            if (response.data === true) {

                                var params3 = {
                                    CustomerCode: cred.AnaSirketKodu,
                                    CompanyCode: cred.SirketKodu,
                                    AccountingCompanyID:cred.MuhasebeSirketNo,
                                    Reverse:this.ficheReverse,
                                    UserID:cred.UserID
                                   
                                }

                                this.$http.post(auth.API_URL + 'api/AccountingParameters/RecieptStream',
                                    params3, {
                                        headers: {
                                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                                        }
                                    }).then((response) => {
                                    if (!response.body[0].Status) {
                                        this.accountingCodedialog = false
                                        this.text1 = response.body[0].Aciklama
                                        this.snackbar = true
                                        this.loadingvmodel = false
                                    } else {
                                        this.accountingCodedialog = false
                                        this.text1 = this.$t('File-transfer-completed')
                                        this.snackbar = true
                                        this.loadingvmodel = false
                                    }

                                }, (response) => {
                                    this.loadingvmodel = false
                                    if (response.status === 0) {
                                        this.progress = false
                                        this.text1 = 'Service Unavailable-AccountingCodeStream'
                                        this.snackbar = true
                                    } else {
                                        this.text1 = 'Service Unavailable-AccountingCodeStream'
                                        this.snackbar = true
                                    }
                                })
                            } else {
                                this.text1 = this.$t('Error-in-file-transfer-try-again')
                                this.snackbar = true
                                this.loadingvmodel = false
                            }
                        })
                        .catch(function () {
                            this.loadingvmodel = false
                            this.text1 = this.$t('Error-in-file-transfer-try-again')
                            this.snackbar = true

                        });
                }
            }
        },
        standartGelirGiderSablonu(){
          this.$refs.standartGelirGiderSablonu.open();
        },
        standartBilancoSablonu(){
          this.$refs.standartBilancoSablonu.open();
        },
        deftersilmeyetkisiDialogAc()
        {
          this.$refs.deftersilmeyetkisi.open();
        },
        kullaniciAdiGuncellegDialogAc()
        {
          this.$refs.kullaniciadiguncelle.open();
        },
        otomatikkapanisfisiDialogAc()
        {
          this.$refs.otomatikkapanisfisi.open();
        },
        kapanistanacilisDialogAc()
        {
          this.$refs.kapanistanacilis.open();
        },
        yuvarlaDialogAc(){
          this.$refs.kurusyuvarla.open();
        },
    firmaSilDialogAc() {
      this.$refs.firmaSil.open();
    },
    firmaKopyalaDialogAc() {
      this.$refs.firmaKopyala.open();
    },
    fisKopyalaDialogAc() {
      this.$refs.fisKopyala.open();
    },
    fisDegistirDialogAc() {
      this.$refs.fisDegistir.open();
    },
    fisDialogAc() {
      this.$refs.fisNumaraDegis.open();
    },
    surumGuncelleAc() {
      this.$refs.surumGuncelle.open();
    },
    referansDialogAc() {
      this.$refs.referansbirlestir.open();
    },
    standartbiletentgDialogAc() {
      this.$refs.standartbiletentg.open();
    }
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      //YETKİ OK
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  },
};

function beforeMount() {}
</script>
